import React from "react";

import { Props } from "./types";

function PenIconHover(props: Props) {
  return (
    <svg className={props.className} viewBox="0 0 59 59">
      <circle
        id="Ellipse_782"
        data-name="Ellipse 782"
        cx="29.5"
        cy="29.5"
        r="29.5"
        fill="gray"
        opacity="0.827"
      />
      <path
        id="Icon_awesome-pen"
        data-name="Icon awesome-pen"
        d="M15.13,4.852l6.662,6.662L7.326,25.982l-5.94.656a1.249,1.249,0,0,1-1.379-1.38l.661-5.944L15.13,4.852Zm10.783-.992L22.785.732a2.5,2.5,0,0,0-3.534,0L16.308,3.675l6.662,6.662,2.943-2.943a2.5,2.5,0,0,0,0-3.534Z"
        transform="translate(17.001 14.354)"
        fill="#ccc"
      />
    </svg>
  );
}

export { PenIconHover };
